import { render, staticRenderFns } from "./MJSlider.vue?vue&type=template&id=d63ca5b4&scoped=true&"
import script from "./MJSlider.vue?vue&type=script&lang=js&"
export * from "./MJSlider.vue?vue&type=script&lang=js&"
import style0 from "./MJSlider.vue?vue&type=style&index=0&id=d63ca5b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63ca5b4",
  null
  
)

export default component.exports